module.exports = __webpack_public_path__ + "static/img/image-placeholder.250008d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image-placeholder.jpeg
// module id = vBaa
// module chunks = 1